import * as types from './mutation-types'
// import * as consts from '../util/const'

export default {
  // 设置token
  [types.LOGIN](state, payload) {
    state.userInfo = payload.user
    state.token = payload.user.token
    state.subscribe = payload.subscribe
  },
  [types.SET_PHONE](state, payload) {
    state.userInfo.mobile = payload
  },
  [types.ENABLE_JSSDK](state) {
    state.jssdkEnabled = true
  },
  [types.DISABLE_JSSDK](state) {
    state.jssdkEnabled = false
  },
  [types.SET_ADDRESS](state, payload) {
    state.address = payload.address
  },
  [types.SCAN_QRCODE](state, payload) {
    state.qrcode = payload
  },
  [types.GET_LOCATION](state, payload) {
    state.location = payload
  },
  [types.SET_AWARDED](state) {
    state.qrcode.awarded = true
  },
  [types.SET_SHOP_OPENID](state, payload) {
    state.shopSubscribe = payload.subscribe
    state.shopOpenId = payload.openid
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js